import React from "react";
import { FaTimes } from "react-icons/fa";
import ModalComponent from "../../../../../../components/ModalComponent";
import CustomInput from "../../../../../../components/CustomInput";

const TagModal = ({
  isOpen,
  handleClose,
  selectedDoc,
  tagInputs,
  setTagInputs,
  handleKeyPress,
  errorMessages,
  removeKeyword,
}) => {
  
  const modalButtons = [
    {
      label: 'Close',
      variant: 'secondary',
      onClick: handleClose
    }
  ];

  return (
    <ModalComponent
      show={isOpen}
      handleClose={handleClose}
      title="Manage Tags"
      footerButtons={modalButtons}
      size="md"
    >
      {selectedDoc && (
        <div className="d-flex flex-column gap-3 p-3">
          
          {/* File Name */}
          <div>
            <strong>File:</strong>{" "}
            <span className="text-muted">{selectedDoc.file_name}</span>
          </div>

          {/* Tag List */}
          <div>
            <strong>Keywords:</strong>
            <div className="d-flex flex-wrap mt-2">
              {selectedDoc.keywords && selectedDoc.keywords.length > 0 ? (
                selectedDoc.keywords.map((keyword, index) => (
                  <span
                    key={index}
                    className="badge bg-primary me-2 mb-2 d-flex align-items-center p-2"
                  >
                    {keyword}
                    <FaTimes
                      className="ms-2 text-dark"
                      style={{ cursor: "pointer" }}
                      onClick={() => removeKeyword(selectedDoc, keyword)}
                    />
                  </span>
                ))
              ) : (
                <span className="text-muted fst-italic small">
                  No tags added yet.
                </span>
              )}
            </div>
          </div>

          {/* Custom Input */}
          <div className="form-group">
            <CustomInput
              label="Add Tag"
              name="tagInput"
              placeholder="Enter tag name and press Enter"
              value={tagInputs[selectedDoc.file_path] || ""}
              onChange={(e) =>
                setTagInputs((prev) => ({
                  ...prev,
                  [selectedDoc.file_path]: e.target.value,
                }))
              }
              onKeyPress={(e) => handleKeyPress(e, selectedDoc.file_path)}
              error={errorMessages[selectedDoc.file_path]}
            />
          </div>

        </div>
      )}
    </ModalComponent>
  );
};

export default TagModal;
